import { render, staticRenderFns } from "./TabReleased.vue?vue&type=template&id=02cb3c56"
import script from "./TabReleased.vue?vue&type=script&lang=js"
export * from "./TabReleased.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports